import React from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';

import Select from './Select';

import { setPaginationPerPageValue } from '../../actions/app';

import { ITEMS_COUNT_ON_PAGE, PER_PAGE_SELECT_OPTIONS } from '../../config';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  max-width: 100%;
  .select-wrapper {
    width: 100px;
    .Select-menu-outer {
      top: auto;
      bottom: 100%;
    }
  }
`;

const PageButtons = (props) => {
  const { pagesCount, currentPage, handlePaginationPage } = props;

  let pageButtons = [];

  for (let index = 0; index < pagesCount; index++) {
    let result = null;
    if (pagesCount > 7) {
      if (currentPage > 6) {
        if (index === 0) {
          result = (
            <li
              className={`page-item ${currentPage === index ? 'active' : ''}`}
              key={`page-${index}`}
              data-testid="page-link"
            >
              <a
                className="page-link"
                href="#"
                onClick={(e) => handlePaginationPage(e, index)}
                data-testid={`page-${index}`}
              >
                {index + 1}
              </a>
            </li>
          );
        } else if (index === 1) {
          result = (
            <li className="page-item page-item-dots" key={`page-${index}`}>
              ...
            </li>
          );
        } else if (index < currentPage - 2) {
          continue;
        } else if (index === currentPage) {
          result = (
            <li
              className={`page-item ${currentPage === index ? 'active' : ''}`}
              key={`page-${index}`}
              data-testid="page-link"
            >
              <a
                className="page-link"
                href="#"
                onClick={(e) => handlePaginationPage(e, index)}
                data-testid={`page-${index}`}
              >
                {index + 1}
              </a>
            </li>
          );
        } else if (pagesCount - currentPage > 7) {
          if (index <= currentPage + 2) {
            result = (
              <li
                className={`page-item ${currentPage === index ? 'active' : ''}`}
                key={`page-${index}`}
                data-testid="page-link"
              >
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => handlePaginationPage(e, index)}
                  data-testid={`page-${index}`}
                >
                  {index + 1}
                </a>
              </li>
            );
          } else if (index === currentPage + 3) {
            result = (
              <li className="page-item page-item-dots" key={`page-${index}`}>
                ...
              </li>
            );
          } else if (index === pagesCount - 1) {
            result = (
              <li
                className={`page-item ${currentPage === index ? 'active' : ''}`}
                key={`page-${index}`}
                data-testid={`page-link`}
              >
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => handlePaginationPage(e, index)}
                  data-testid={`page-${index}`}
                >
                  {index + 1}
                </a>
              </li>
            );
          } else {
            continue;
          }
        } else {
          result = (
            <li
              className={`page-item ${currentPage === index ? 'active' : ''}`}
              key={`page-${index}`}
              data-testid="page-link"
            >
              <a
                className="page-link"
                href="#"
                onClick={(e) => handlePaginationPage(e, index)}
                data-testid={`page-${index}`}
              >
                {index + 1}
              </a>
            </li>
          );
        }
      } else {
        if (pagesCount - currentPage > 7) {
          if (index <= currentPage + 2) {
            result = (
              <li
                className={`page-item ${currentPage === index ? 'active' : ''}`}
                key={`page-${index}`}
                data-testid="page-link"
              >
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => handlePaginationPage(e, index)}
                  data-testid={`page-${index}`}
                >
                  {index + 1}
                </a>
              </li>
            );
          } else if (index === currentPage + 3) {
            result = (
              <li className="page-item page-item-dots" key={`page-${index}`}>
                ...
              </li>
            );
          } else if (index === pagesCount - 1) {
            result = (
              <li
                className={`page-item ${currentPage === index ? 'active' : ''}`}
                key={`page-${index}`}
                data-testid="page-link"
              >
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => handlePaginationPage(e, index)}
                  data-testid={`page-${index}`}
                >
                  {index + 1}
                </a>
              </li>
            );
          } else {
            continue;
          }
        } else {
          result = (
            <li
              className={`page-item ${currentPage === index ? 'active' : ''}`}
              key={`page-${index}`}
              data-testid="page-link"
            >
              <a
                className="page-link"
                href="#"
                onClick={(e) => handlePaginationPage(e, index)}
                data-testid={`page-${index}`}
              >
                {index + 1}
              </a>
            </li>
          );
        }
      }
    } else {
      result = (
        <li
          className={`page-item ${currentPage === index ? 'active' : ''}`}
          key={`page-${index}`}
          data-testid="page-link"
        >
          <a
            className="page-link"
            href="#"
            onClick={(e) => handlePaginationPage(e, index)}
            data-testid={`page-${index}`}
          >
            {index + 1}
          </a>
        </li>
      );
    }
    pageButtons.push(result);
  }
  return pageButtons;
};

const Pagination = (props) => {
  const {
    total,
    currentPage = 0,
    perPage = ITEMS_COUNT_ON_PAGE,
    withPerPageCountSelect = false,
    appStateKey,
    onPageSelect,
    onPerPageSelect,
    perPageSelectOptions = PER_PAGE_SELECT_OPTIONS,
    alignCenter = false,
    itemsNaming = 'элементов',
  } = props;

  const dispatch = useDispatch();

  const { t } = useAutoTranslation();

  const handlePaginationPage = (e, pageIndex) => {
    e.preventDefault();
    onPageSelect(pageIndex);
  };

  const handleChangePerPage = (perPageValue) => {
    if (appStateKey) {
      dispatch(setPaginationPerPageValue({ key: appStateKey, value: perPageValue }));
    }
    onPerPageSelect(perPageValue);
  };

  if (total <= perPage && !withPerPageCountSelect) return null;
  const pagesCount = total % perPage ? Math.trunc(total / perPage) + 1 : total / perPage;

  const itemsNameTranslated = t(`Всего ${itemsNaming}`) || `Всего ${itemsNaming}`;

  return (
    <Wrapper className="row" data-testid="pagination">
      <div
        className="col-12"
        style={alignCenter ? { display: 'flex', justifyContent: 'center' } : null}
      >
        <div className="float-right" style={{ display: 'flex', alignItems: 'center' }}>
          <span className="mr-4">
            {itemsNameTranslated}:&nbsp;
            <span className="font-weight-bold">{total}</span>
          </span>
          {withPerPageCountSelect ? (
            <>
              <label style={{ marginBottom: 0 }}>{t('На странице')}:</label>
              <div className="select-wrapper my-2 ml-2">
                <Select
                  value={perPageSelectOptions.find((p) => p.value === perPage)}
                  options={perPageSelectOptions}
                  menuPlacement="top"
                  onChange={({ value }) => handleChangePerPage(value)}
                  isClearable={false}
                />
              </div>
            </>
          ) : null}
          {total > perPage ? (
            <ul className="pagination pagination-rounded justify-content-end my-2 ml-2">
              <li className="page-item page-pre" data-testid="page-pre">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => handlePaginationPage(e, currentPage !== 0 ? currentPage - 1 : 0)}
                >
                  ‹
                </a>
              </li>
              <PageButtons
                {...props}
                pagesCount={pagesCount}
                handlePaginationPage={handlePaginationPage}
              />
              <li className="page-item page-next" data-testid="page-next">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) =>
                    handlePaginationPage(
                      e,
                      currentPage !== pagesCount - 1 ? currentPage + 1 : pagesCount - 1,
                    )
                  }
                >
                  ›
                </a>
              </li>
            </ul>
          ) : null}
        </div>
      </div>
    </Wrapper>
  );
};

export default Pagination;
